import type { NumberOptions } from "shelving";
import { formatNumber, formatQuantity } from "shelving";

const CRAM_NUMBER_OPTIONS: NumberOptions = {
	notation: "compact",
	maximumSignificantDigits: 3,
	maximumFractionDigits: 2,
	roundingMode: "trunc",
	roundingPriority: "lessPrecision",
};

/** Format a number as a compact number with three significant digits, e.g. `1.24K` or `112B` */
export const formatCompactNumber = (num: number): string => formatNumber(num, CRAM_NUMBER_OPTIONS);

/** Format a quantity as a compact number with three significant digits, e.g. `1.24K` or `112B` */
export const formatCompactQuantity = (num: number, abbr: string): string => formatQuantity(num, abbr, CRAM_NUMBER_OPTIONS);

/** Pluralize a quantity with a compact number, e.g. `1 reply` or `112B replies` */
export function pluralizeCompactQuantity(num: number, singular: string, plural: string): string {
	const qty = formatCompactNumber(num);
	return `${qty} ${qty === "1" ? singular : plural}`;
}
